// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Card-Body-module--cls1--3N6FK","cls2":"Card-Body-module--cls2--gQT8U Card-Body-module--cls1--3N6FK"};